export class AmountUtils {
  static transformToAmount = (amount?: number | string) => {
    if (typeof amount !== 'number' || isNaN(amount)) return '-';
    return ` ${amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  static amountChange = (value: string, onChange: (value: number | undefined) => void) => {
    if (typeof value !== 'string') return;

    if (value.startsWith('-')) return;

    const correctedValue = value.replace(/^(\d+)(\.\d{0,2})?\d*$/, (_, p1, p2) => {
      if (p2) return p1 + p2.padEnd(3, '0').slice(0, 3);
      else return p1;
    });
    if (correctedValue !== '') {
      const floatValue = parseFloat(correctedValue.replace(',', '.'));
      onChange(floatValue);
    } else onChange(undefined);
  };
}
